import './SettlementElementPanel.css';

interface Props {
  title: string;
  children?: React.ReactNode;
  className?: string;
}

export const SettlementElementPanel = ({ title, children }: Props) => {
  return (
    <div className="settlement-email-template-element">
      <div className="settlement-email-template-element__title"> {title} </div>
      <div className="settlement-email-template-element__body"> {children} </div>
    </div>
  );
};
